import { s } from "@kosmod/pancake";
import { mod } from "@kosmod/kit";
import { defineToolHandler } from "./handler";
import { tools } from "../../defs";

const states = [
  'none',
  'interior',
  'visibility',
  'walkable',
  'neighbors'
] as const;

defineToolHandler(tools.dev.vis, {
  def: tools.dev.vis,

  onSelect(state, tools, selection, logger) {
    logger.log('TOOL SELECT', tools.activeTool)
    if (state.id === tools.activeTool) {
      const stateIndex = states.indexOf(state.canvas);
      const nextCanvas = states[mod(stateIndex + 1, states.length)];
      tools.setToolState(state.id, { ...state, canvas: nextCanvas });
    }
  },
  onInput(event, state, theatre, logger) {
    
  },

  ToolbeltComponent({ toolState }) {
    return toolState.canvas
  }
})